export const IDENTITY_VERIFICATION_SUCCESS = 'IDENTITY_VERIFICATION_SUCCESS';
export const identityVerificationSuccess = (successNotification) => ({
  type: IDENTITY_VERIFICATION_SUCCESS,
  payload: { successNotification },
});

export const IDENTITY_VERIFICATION_PENDING = 'IDENTITY_VERIFICATION_PENDING';
export const identityVerificationPending = (pendingNotification) => ({
  type: IDENTITY_VERIFICATION_PENDING,
  payload: { pendingNotification },
});
